var map = {
	"./alert_camera.png": 15,
	"./alert_microphone.png": 16,
	"./alert_mute.png": 17,
	"./arrow-next.png": 18,
	"./arrow-repeat.png": 19,
	"./audio-icon.png": 20,
	"./avatars/AvatarArabella1.png": 21,
	"./avatars/AvatarArabella2.png": 22,
	"./avatars/AvatarArabella3.png": 23,
	"./avatars/AvatarArabella4.png": 24,
	"./avatars/AvatarArabella5.png": 25,
	"./avatars/AvatarChloe1.png": 26,
	"./avatars/AvatarChloe2.png": 27,
	"./avatars/AvatarChloe3.png": 28,
	"./avatars/AvatarChloe4.png": 29,
	"./avatars/AvatarChloe5.png": 30,
	"./avatars/AvatarChloe6.png": 31,
	"./camera.png": 32,
	"./close-icon.png": 33,
	"./dev_next.png": 34,
	"./dev_prev.png": 35,
	"./difficulty_1.png": 36,
	"./difficulty_1_a.png": 37,
	"./difficulty_1_b.png": 38,
	"./difficulty_2.png": 39,
	"./difficulty_2_a.png": 40,
	"./difficulty_2_b.png": 41,
	"./difficulty_3.png": 42,
	"./difficulty_3_a.png": 43,
	"./difficulty_3_b.png": 44,
	"./difficulty_4.png": 45,
	"./difficulty_4_a.png": 46,
	"./difficulty_4_b.png": 47,
	"./difficulty_5.png": 48,
	"./difficulty_5_a.png": 49,
	"./difficulty_5_b.png": 50,
	"./difficulty_6.png": 51,
	"./difficulty_6_a.png": 52,
	"./difficulty_6_b.png": 53,
	"./dummy_image_chicken.png": 54,
	"./dummy_image_cow.png": 55,
	"./dummy_image_duck.png": 56,
	"./dummy_image_horse.png": 57,
	"./dummy_image_mini-adventure.png": 58,
	"./dummy_image_pig.png": 59,
	"./dummy_image_sheep.png": 60,
	"./fantastisch.mp3": 61,
	"./ga_zo_door_2.mp3": 62,
	"./gevonden_rustig.mp3": 63,
	"./geweldig_1.mp3": 64,
	"./gewonnen_level_1_opgewekt.mp3": 65,
	"./gewonnen_level_2_opgewekt.mp3": 66,
	"./gewonnen_level_3_opgewekt.mp3": 67,
	"./gewonnen_level_4_opgewekt.mp3": 68,
	"./gewonnen_level_5_opgewekt.mp3": 69,
	"./gewonnen_level_6_opgewekt.mp3": 70,
	"./glow.png": 71,
	"./goed_gedaan.mp3": 72,
	"./goed_zo_2.mp3": 73,
	"./level_1_rustig.mp3": 74,
	"./level_2_rustig.mp3": 75,
	"./level_3_rustig.mp3": 76,
	"./level_4_rustig.mp3": 77,
	"./level_5_rustig.mp3": 78,
	"./level_6_rustig.mp3": 79,
	"./nog_een_keer.mp3": 80,
	"./ok_button.png": 81,
	"./prize_1.png": 82,
	"./prize_2.png": 83,
	"./prize_3.png": 84,
	"./prize_4.png": 85,
	"./prize_5.png": 86,
	"./prize_6.png": 87,
	"./progress.png": 88,
	"./super_opgewekt.mp3": 89,
	"./terug_2.mp3": 90,
	"./treasury.png": 91,
	"./verder_spelen.mp3": 92,
	"./wat_knap_2.mp3": 93,
	"./wauw_rustig.mp3": 94
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared ^\.\/.*$
// module id = 6
// module chunks = 0